<template>
  <b-collapse :key="componentKey" class="panel">
    <div slot="trigger" class="panel-heading"><strong>Dettagli</strong></div>
    <div class="panel-block">
      <form style="width:100%" @submit.prevent="submit">
        <b-field
          :type="errors['code'] ? 'is-danger' : ''"
          :message="errors['code']"
          label="Codice"
        >
          <b-input
            size="is-medium"
            :value="item['code']"
            @input="update('code', $event)"
          />
        </b-field>
        <b-field
          :type="errors['description'] ? 'is-danger' : ''"
          :message="errors['description']"
          label="Descrizione"
        >
          <b-input
            type="textarea"
            size="is-medium"
            :value="item['description']"
            @input="update('description', $event)"
          />
        </b-field>
        <b-field
          :type="errors['is_legacy'] ? 'is-danger' : ''"
          :message="errors['is_legacy']"
          label="Versione obsoleta"
        >
          <b-checkbox
            size="is-medium"
            :value="item['is_legacy']"
            @input="update('is_legacy', $event)"
          ></b-checkbox>
        </b-field>
        <footer v-if="!isEmpty(formData)" style="margin-top: 1.5em">
          <div class="buttons">
            <button class="button" type="button" @click="reset">
              <b-icon icon="undo"></b-icon>
              <span>Annulla</span>
            </button>
            <button class="button is-primary" type="submit">
              <b-icon icon="save"></b-icon>
              <span>Salva</span>
            </button>
          </div>
        </footer>
      </form>
    </div>
  </b-collapse>
</template>

<script>
import isEmpty from "lodash/isEmpty"
import { call } from "vuex-pathify"

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    submitAction: {
      type: Function,
      default: call("productTypes/update")
    },
    redirectRoute: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      componentKey: 0, // used to force rerender
      formData: {},
      errors: {}
    }
  },
  methods: {
    isEmpty,
    reset() {
      this.errors = {}
      this.formData = {}
      this.componentKey += 1
    },
    update(name, value) {
      this.$set(this.formData, name, value)
    },
    async submit() {
      try {
        let response, message

        if (!isEmpty(this.item)) {
          // if we're editing
          response = await this.submitAction({
            id: this.item.id,
            data: this.formData
          })
          message = "Modificato con successo"
        } else {
          // if it's a new item
          response = await this.submitAction(this.formData)
          message = "Creato con successo"
        }
        this.$toast.open({
          message,
          type: "is-success"
        })

        // if the `redirectRoute` prop is set, redirect to the
        // path with that name.
        // as a convention, we always pass an `id` param with
        // the value coming from the previous response.
        if (this.redirectRoute) {
          this.$router.push({
            name: this.redirectRoute,
            params: { id: response.id }
          })
        } else {
          this.reset()
        }
      } catch (response) {
        // show errors in form
        this.errors = {}
        Object.keys(response.data).forEach(key => {
          this.$set(this.errors, key, response.data[key].join(" "))
        })
      }
    }
  }
}
</script>

<style lang="sass">
.columns.is-gapless > .column
  margin-bottom: 10px
.field label
  font-size: 0.8rem
  text-transform: uppercase
</style>
